import React, {useState} from "react";
import Select from "react-select";
import {Text, View} from "@/styles/reactnative";
import {useTranslation} from "react-i18next";
import {useFetcherPublic} from "@app/hooks/fetcher";
import {getSetting, useSetting} from "@app/hooks/user/mysetting";
import {SETTING_TYPE_SYSTEM} from "@app/constants/SETTING";
import NotiSwitch from "../../NotiSwitch";
import styled from "styled-components";
import {media} from "@/styles/Qtheme.ts";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";

interface IProps {
  select?: string;
  setSelect?: any;
  title?: string;
  content?: string;
}

const NotificationBox = ({select, setSelect, title, content}: IProps) => {
  const {t} = useTranslation();
  const isMobile = useIsMobile();

  const {data: supportLanguage} = useFetcherPublic("/system/language", false);

  const {data: setting, updateSetting} = useSetting(SETTING_TYPE_SYSTEM);
  const notification = getSetting(setting, "NOTILANG", "EN");

  const [event, setEvent] = useState<boolean>(true);
  const [announcement, setAnnouncement] = useState<boolean>(true);
  const [alert, setAlert] = useState<boolean>(true);

  // 영어와 한국어만 필터링
  const filteredLanguages = supportLanguage?.result?.result?.filter((item: any) => {
    const code = item?.code?.toLowerCase();
    return code === 'en' || code === 'ko';
  });

  const notificationsOptions = filteredLanguages?.map(
    (item: any) => {
      return {
        value: item?.code,
        label: item?.name,
      };
    },
  );

  const customStyles = {
    container: (provided: any) => ({
      ...provided,
      width: "100%",
      cursor: "pointer",
    }),
    control: (provided) => ({
    ...provided,
    cursor: "pointer", // 클릭 영역에 커서 적용
  }),
  };

  return (
    <View
      style={{
        width: "100%",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: '20px 10px',
        gap: 10,
      }}
    >

      <View
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "flex-start",
          display: "flex",
          flexDirection: isMobile ? 'column' : "row",
          marginBottom: 10
        }}
      >
        <Contents style={{display: "flex", flexDirection: "column", gap: 16,  marginBottom: isMobile ? 20 : undefined}}>

          <Text size={20} style={{fontWeight: "500", marginBottom: isMobile ? 10 : undefined }}>
            {t("notification")}
          </Text>

          <Text size={18} style={{fontWeight: "400", color: "#F87943", lineHeight: 1 }}>
            {t("notificationLanguage")}
          </Text>
        </Contents>

        <View style={{width: isMobile ? '100%' : "40%"}}>
          <Select
            defaultValue={notificationsOptions?.find(
              (item: any) => item.value === notification,
            )}
            options={notificationsOptions}
            styles={customStyles}
            onChange={({value}: any) => {
              updateSetting("NOTILANG", value);
            }}
          />
        </View>
      </View>
      {/*<NotiSwitch*/}
      {/*  title={t("latestEvents")}*/}
      {/*  checked={event}*/}
      {/*  setChecked={setEvent}*/}
      {/*/>*/}
      {/*<NotiSwitch*/}
      {/*  title={t("announcement")}*/}
      {/*  checked={announcement}*/}
      {/*  setChecked={setAnnouncement}*/}
      {/*/>*/}
      <NotiSwitch
        title={t("tradingViewAlerts")}
        checked={alert}
        setChecked={setAlert}
      />
    </View>
  );
};

export default React.memo(NotificationBox);

const Contents = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;

    @media ${media.mobile} {
        margin-top: ${MobileCalVW(20)};
        gap: ${MobileCalVW(12)};
    }
`;
